import { render, staticRenderFns } from "./BlowMoldingMachineView.vue?vue&type=template&id=6ba6c8b2&"
import script from "./BlowMoldingMachineView.vue?vue&type=script&lang=js&"
export * from "./BlowMoldingMachineView.vue?vue&type=script&lang=js&"
import style0 from "./BlowMoldingMachineView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports